import './Home.css';
import backgroundImage from './assets/home.jpeg';
import peanuts_clean from './assets/peanuts_clean.png';

function Home() {
    return (
        <>
            <div className="home-background" style={{ backgroundImage: `url(${backgroundImage})` }}>
                <div className="intro-card">
                    <h1 className="greetings">Welcome!</h1>
                    <div className="about-text">
                        <p>Feel free to look around!</p>
                    </div>
                </div>
                <img src={peanuts_clean} alt="Peanuts One" className="home-image" />
            </div>
        </>
    );
};

export default Home;